import { createContext } from 'react';

import { SettingsData } from '@common/types/api';

export type EventContextData = SettingsData;

export const EventContext =
  createContext<EventContextData | undefined>(undefined);
EventContext.displayName = 'EventContext';
